// extracted by mini-css-extract-plugin
export default {"modalHeight":"CommonModal_modalHeight__WKWl7","modalBody":"CommonModal_modalBody__vC7jX"};